import { useState, useEffect } from 'react';

export default function Hero() {
  const [showGlitch, setShowGlitch] = useState(false);

  useEffect(() => {
    const glitchInterval = setInterval(() => {
      setShowGlitch(true);
      setTimeout(() => setShowGlitch(false), 200);
    }, 8000);

    return () => clearInterval(glitchInterval);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/ad7e6ab220c2b84dfe2595382bc01d93.jpeg"
          alt="Dark cityscape"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-radial from-transparent via-black/40 to-black/80"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/60"></div>
      </div>

      {/* Glitch Effect Overlay */}
      {showGlitch && (
        <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 via-transparent to-blue-500/10 animate-pulse pointer-events-none"></div>
      )}

      {/* Scanline Effect */}
      <div className="absolute inset-0 scanline-effect pointer-events-none"></div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6">
        <div className="text-center">
          {/* Logo */}
          <div className="mb-8 flex justify-center">
            <img
              src="https://public.readdy.ai/ai/img_res/e6afb061-4e53-4ae3-af11-74d83acf09de.png"
              alt="Canadian Nightmares Logo"
              className="h-24 w-auto logo-glow"
            />
          </div>

          {/* Main Title */}
          <h1 className="text-4xl md:text-5xl font-black tracking-[0.15em] mb-6 title-glow animate-subtle-shake">
            CANADIAN NIGHTMARES
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl tracking-[0.3em] text-[#ff0033] font-bold mb-16">
            MUSIC FOR THE RESISTANCE
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col md:flex-row gap-5 justify-center items-center">
            <button
              onClick={() => scrollToSection('featured-music')}
              className="group relative px-12 py-4 bg-[#ff0033] text-white font-bold text-sm tracking-wider rounded-full hover:shadow-[0_0_30px_rgba(255,0,51,0.6)] transition-all duration-300 hover:scale-105 whitespace-nowrap w-48 flex items-center justify-center"
            >
              LISTEN NOW
              <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
            </button>
            <button
              onClick={() => scrollToSection('featured-music')}
              className="px-12 py-4 border-2 border-[#ff0033] text-white font-bold text-sm tracking-wider rounded-full hover:bg-[#ff0033]/10 hover:shadow-[0_0_30px_rgba(255,0,51,0.4)] transition-all duration-300 hover:scale-105 whitespace-nowrap w-48"
            >
              LATEST RELEASE
            </button>
            <a
              href="https://www.youtube.com/watch?v=ph_0oFvlUSU"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="px-12 py-4 border-2 border-[#4dd0e1] text-white font-bold text-sm tracking-wider rounded-full hover:bg-[#4dd0e1]/10 hover:shadow-[0_0_30px_rgba(77,208,225,0.4)] transition-all duration-300 hover:scale-105 whitespace-nowrap w-48 flex items-center justify-center"
            >
              WATCH VIDEO
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-3xl"></i>
      </div>
    </section>
  );
}
